import { SYSBaseElement, html } from "../../../../../../_ovlclient/src"
import { FileGet } from "../../../../../../_ovlclient/src/global/globalapi"
import { ProcessIsRunning } from "../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { FileType } from "../filelist/filelist"

export type DownloadPopup = {
  activePopupKey: string
  docNum: string
  documentScreensState: any
  documentDetailsState: any

  popupId: string
  type: string
  onOpen?: () => Promise<void>
}

export class CompDownloadPopup extends SYSBaseElement {
  props: any
  popupState: DownloadPopup
  async init() {
    this.popupState = this.props()
    await super.init()
  }

  handleFile(e: Event, fileName: string, fileType: FileType, docNum: string) {
    e.preventDefault()
    this.actions.app.global.actions.TogglePDFPopup({
      key: this.popupState.popupId,
      obj: this.popupState.documentScreensState,
    })
    let data = { cat: fileType, id1: fileName, id2: docNum, ext: "" }
    FileGet(data)
  }
  async getUI() {
    this.popupState = this.props()
    const handlePDFPopup = async (e: Event) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.popupState.onOpen) {
        await this.popupState.onOpen()
      }

      let id = this.popupState.docNum
      if (this.popupState.activePopupKey === id) {
        id = ""
      }
      this.actions.app.global.actions.TogglePDFPopup({
        key: id,
        obj: this.popupState.documentScreensState,
      })
    }

    let files: File[] = []
    const docData = this.popupState.documentDetailsState[this.popupState.docNum]
    if (this.popupState.type === "Order") {
      files = docData?.steps?.step2?.attachments?.files || []
    } else {
      files = docData?.attachments?.files || []
    }

    return html`<div class="fd-popover">
      <div class="fd-popover__control">
        <button
          ?disabled=${ProcessIsRunning("GENRefreshData")}
          @click=${handlePDFPopup}
          class="fd-button fd-button--compact "
          aria-controls=${this.popupState.popupId + this.popupState.docNum}
          aria-haspopup="true"
          aria-expanded=${this.popupState.docNum ===
          this.popupState.activePopupKey}
          aria-label="More"
        >
          <span class="sap-icon--pdf-attachment"></span>
        </button>
      </div>
      <div
        class="fd-popover__body"
        aria-hidden=${this.popupState.docNum !==
          this.popupState.activePopupKey ||
        files.filter((m) => m.type === this.popupState.type).length === 0}
        id=${this.popupState.popupId + this.popupState.docNum}
      >
        <nav class="fd-menu">
          <ul class="fd-menu__list" role="menu">
            ${(docData?.attachments?.files || [])
              .filter((m) => m.type === this.popupState.type)
              .map((f) => {
                return html`
                  <li class="fd-menu__item " role="button">
                    <a
                      href=""
                      @click=${(e) =>
                        this.handleFile(
                          e,
                          f.fileName,
                          f.type,
                          this.popupState.docNum
                        )}
                      role="menuitem"
                      class="fd-menu__link"
                      >${f.fileName}
                    </a>
                  </li>
                `
              })}
          </ul>
        </nav>
      </div>
    </div> `
  }
}
